import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'

import ResellerBanner from '@/components/ResellerBanner.vue'
import { mapRelationship } from '@/store/mappers'


export default {
  __name: 'ResellerCustomerBanner',
  props: {
  conversationUserPairId: { type: [String, Number], required: true }
},
  setup(__props) {

const props = __props

const pair = computed(() =>
  mapRelationship({ type: 'conversation_user_pair', id: String(props.conversationUserPairId) })
)
const resellerId = computed(() => pair.value?.attributes?.reseller_id)

return (_ctx, _cache) => {
  return (resellerId.value)
    ? (_openBlock(), _createBlock(ResellerBanner, {
        key: 0,
        "reseller-id": resellerId.value,
        message: "This is a reseller customer, managed by"
      }, null, 8, ["reseller-id"]))
    : _createCommentVNode("", true)
}
}

}